// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IAnnotationItem,
    IAnnotationQuote,
    IAnnotationCommentValue,
}                               from '../interfaces';

// ===== Enums =====

import {
    ZOOM_LEVEL,
}                               from '../components/Editor/elements/enums';
import runCallableWithRetry      from './runCallableWithRetry';

const createAnnotation = async ({
    test,
    postId,
    isComment,
    value,
    text,
    comment,
    quote,
    mediaIds,
    zoomLevel,
    chapterId,
    sectionId,
    requestId,
}: {
    test: boolean,
    postId: string,
    isComment: boolean,
    value: string,
    text: string,
    comment?: IAnnotationCommentValue,
    quote?: IAnnotationQuote,
    mediaIds: string[],
    zoomLevel: ZOOM_LEVEL,
    chapterId?: string,
    sectionId?: string,
    // Client-supplied idempotency key so retries don't create duplicates.
    requestId?: string,
}): Promise<IAnnotationItem> => {
    const functions = getFunctions();
    const handleCreateAnnotation = httpsCallable<
        Record<
            string,
            boolean | string | number | string[] | IAnnotationQuote | IAnnotationCommentValue | ZOOM_LEVEL | undefined
        >,
        IAnnotationItem
    >(
        functions,
        'createAnnotation',
    );
    const payload = {
        test,
        postId,
        isComment,
        value,
        text,
        comment,
        quote,
        mediaIds,
        zoomLevel,
        chapterId,
        sectionId,
        requestId,
    };

    const result = await runCallableWithRetry(
        () => handleCreateAnnotation(payload),
        {
            maxAttempts: 4,
            baseDelayMs: 120,
        },
    );
    return result.data as IAnnotationItem;
};

export default createAnnotation;
